import { DateTime } from 'luxon';
import * as yup from 'yup';
function isRequired(errorMessage) {
    return yup
        .string()
        .trim()
        .required(errorMessage);
}
function conditionallyRequired(formikInputString, errorMessage) {
    if (formikInputString === void 0) { formikInputString = 'billingAddressRequired'; }
    if (errorMessage === void 0) { errorMessage = 'Required'; }
    return yup.mixed().when(formikInputString, {
        is: true,
        then: isRequired(errorMessage),
    });
}
export var detailsSchema = yup.object().shape({
    abn: yup.mixed().when('isBusiness', {
        is: true,
        then: isRequired('Please enter an ABN').matches(/^\d+$/, 'Please enter a valid ABN'),
    }),
    billingAddressLevelNumber: yup
        .string()
        .matches(/^[a-zA-Z0-9]{1,5}$/, 'Level number must not exceed 5 alphanumeric characters.'),
    billingAddressPostcode: yup.mixed().when('billingAddressRequired', {
        is: true,
        then: isRequired('Please enter a valid postcode').matches(/^\d{4}$/, 'Please enter a valid postcode'),
    }),
    billingAddressState: yup.mixed().when('billingAddressRequired', {
        is: true,
        then: isRequired('Please select a state').test('not-null', 'Please select a street type', function (val) { return val !== 'Please select'; }),
    }),
    billingAddressStreetName: conditionallyRequired('billingAddressRequired', 'Please enter a street name'),
    billingAddressStreetNumber: yup
        .string()
        .matches(/^[a-zA-Z0-9]{1,5}$/, 'Street number must not exceed 5 alphanumeric characters.'),
    billingAddressStreetType: yup.mixed().when('billingAddressRequired', {
        is: true,
        then: isRequired('Please select a street type').test('not-null', 'Please select a street type', function (val) { return val !== 'Please select'; }),
    }),
    billingAddressSuburb: conditionallyRequired('billingAddressRequired', 'Please enter a suburb'),
    billingAddressUnitNumber: yup
        .string()
        .matches(/^[a-zA-Z0-9]{1,5}$/, 'Unit number must not exceed 5 alphanumeric characters.'),
    businessName: conditionallyRequired('isBusiness', 'Please enter a business name'),
    dateOfBirth: yup
        .mixed()
        .test('valid-date', 'Please enter a valid date', function (val) {
        var currentDate = DateTime.now();
        var dateOfBirth = DateTime.fromFormat(val, 'dd/MM/yyyy');
        var diff = currentDate.diff(dateOfBirth, 'years');
        return diff.as('years') <= 120 && dateOfBirth.isValid;
    })
        .test('valid-length', 'Please enter a valid date', function (val) {
        return val ? val.replace(/[/_]/g, '').length === 8 : false;
    })
        .test('is-of-age', 'Must be 18 years or older to sign up', function (val) {
        var currentDate = DateTime.now();
        var dateOfBirth = DateTime.fromFormat(val, 'dd/MM/yyyy');
        var diff = currentDate.diff(dateOfBirth, 'years');
        return diff.as('years') >= 18;
    }),
    deliveryAddressLevelNumber: yup
        .string()
        .matches(/^[a-zA-Z0-9]{1,5}$/, 'Level number must not exceed 5 alphanumeric characters.'),
    deliveryAddressPostcode: yup.mixed().when('deliveryAddressRequired', {
        is: true,
        then: isRequired('Please enter a valid postcode').matches(/^\d{4}$/, 'Please enter a valid postcode'),
    }),
    deliveryAddressRequired: yup.boolean(),
    deliveryAddressState: yup.mixed().when('deliveryAddressRequired', {
        is: true,
        then: isRequired('Please select a state').test('not-null', 'Please select a street type', function (val) { return val !== 'Please select'; }),
    }),
    deliveryAddressStreetName: yup.mixed().when('deliveryAddressRequired', {
        is: true,
        then: isRequired('Please enter a street name'),
    }),
    deliveryAddressStreetNumber: yup
        .string()
        .matches(/^[a-zA-Z0-9]{1,5}$/, 'Street number must not exceed 5 alphanumeric characters.'),
    deliveryAddressStreetType: yup.mixed().when('deliveryAddressRequired', {
        is: true,
        then: isRequired('Please select a street type').test('not-null', 'Please select a street type', function (val) { return val !== 'Please select'; }),
    }),
    deliveryAddressSuburb: conditionallyRequired('deliveryAddressRequired', 'Please enter a suburb'),
    deliveryAddressUnitNumber: yup
        .string()
        .matches(/^[a-zA-Z0-9]{1,5}$/, 'Unit number must not exceed 5 alphanumeric characters.'),
    emailAddress: yup
        .string()
        .required('A valid email is required')
        .email('Please enter a valid email')
        .max(50, 'Email address is too long'),
    firstName: isRequired('Please enter a correct name')
        .matches(/^\S+(\s\S+)*$/, 'only single space allowed between words')
        .max(15, 'Maximum of 15 characters'),
    lastName: isRequired('Please enter a correct name')
        .matches(/^\S+(\s\S+)*$/, 'only single space allowed between words')
        .max(15, 'Maximum of 15 characters'),
    phoneNumber: yup.mixed().when('phoneType', function (value) {
        switch (value) {
            case 'mobile':
                return isRequired('Mobile number is required').matches(/^04[0-9]{8}$/, 'Please enter a valid mobile phone number');
            case 'home':
                return isRequired('Home number is required').matches(/^0(2|3|7|8)[0-9]{8}$/, 'Please enter a valid home phone number');
            case 'work':
                return isRequired('Work number is required').matches(/^0(2|3|4|7|8)[0-9]{8}$/, 'Please enter a valid work phone number');
            default:
                return isRequired("Please enter a valid phone number");
        }
    }),
    phoneType: isRequired('Please select a phone type'),
    title: isRequired('Required'),
}, [['abn', 'businessName']]);
//# sourceMappingURL=detailsSchema.js.map